import React from 'react'
import { useTranslation } from "react-i18next"
import { Grid } from '@material-ui/core'
import { LocalStorageService } from '../../../services'
import './dialog-resend-signature-request.css'
import { ButtonHLPure, DialogTemplatePure, DialogYesNoHLPure } from '..'


const DialogResendSignatureRequest = (props) => {
    const { t } = useTranslation()

    const containerLabelMessage = {
        textAlign: 'center',
        marginBlock: '30px'
    }

    let localStorageService = new LocalStorageService()
    const userSesionCurrent = localStorageService.getLocalStorageItem('user').userMetaData.userMifirma.email

    return (
        <>
            {(props?.signatureRequest?.signRequest?.signRequestStatus?.id === Number(process.env.REACT_APP_SIGN_REQUEST_STATUS_COMPLET) && props?.userCanResendInformation === true && props.signRequest.user.email === userSesionCurrent) ?
                <div>
                    {/* Button to display the dialog */}
                    <ButtonHLPure
                        nameBtn={t('dialogResendSignatureRequest.buttonResendInformation')}
                        onClickBtn={props.toggleDialogResendSignatureRequest}
                    />

                    {/* Dialog to resend the information */}
                    {props.visibleDialogResendSignatureRequest &&
                        <DialogYesNoHLPure
                            titleDialog={t('dialogResendSignatureRequest.titleDialogResendSignatureRequest')}
                            cancel={props.toggleDialogResendSignatureRequest}
                            textBtnCancel={t('dialogResendSignatureRequest.buttonClose')}
                            handleSubmit={props.onResendSignatureRequest}
                            saveBtn={t('dialogResendSignatureRequest.buttonSend')}
                            loadingComponent={props.showLoadingRequesting}
                            saveError={props.showErrorRequesting}
                        >
                            {/* Container global */}
                            <Grid container xs={12} lg={12} md={12} sm={12} es={12}>
                                {/* Label y TextArea */}
                                <Grid item xs={12} lg={12} md={12} sm={12} es={12} style={containerLabelMessage}>
                                    <p>{t('dialogResendSignatureRequest.labelDoYouWantToResendInformation')}</p>
                                </Grid>
                            </Grid>
                        </DialogYesNoHLPure>
                    }
                </div>
                : null}
        </>
    )
}

export { DialogResendSignatureRequest as default }